<script setup>
/**
 * What the collapsed sidepanel leaves behind: a strip carrying the same panel
 * tabs as icons, so closing the panel does not hide which panels exist - and
 * reopening lands on the one that was picked rather than the last one.
 *
 * Shared by the tickets thread and the chat inbox, which keep their panel state
 * in different places (a local mode vs. the `is_*_panel_open` UI settings), so
 * the rail owns no state of its own: it is given the tabs and the active key.
 */
defineProps({
  // [{ key, icon, label }] - labels arrive translated, the rail has no strings.
  tabs: { type: Array, required: true },
  activeKey: { type: String, default: '' },
  testId: { type: String, default: 'sidepanel-rail' },
});

const emit = defineEmits(['select']);
</script>

<template>
  <div
    :data-testid="testId"
    class="flex flex-col items-center h-full gap-1 py-3"
  >
    <button
      v-for="tab in tabs"
      :key="tab.key"
      type="button"
      :data-testid="`${testId}-${tab.key}`"
      :title="tab.label"
      :aria-label="tab.label"
      :aria-pressed="tab.key === activeKey"
      class="grid rounded-lg size-9 place-items-center"
      :class="
        tab.key === activeKey
          ? 'bg-n-violet-3 text-n-violet-11'
          : 'text-n-slate-11 hover:bg-n-alpha-1'
      "
      @click="emit('select', tab.key)"
    >
      <span :class="tab.icon" class="size-4" />
    </button>
  </div>
</template>
